import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { api } from "../services/api";

interface User {
  _id: string;
  name: string;
  email: string;
}

interface AuthState {
  token: string;
  user: User;
}

interface SignInCredencials {
  email: string;
  password: string;
}

interface SignOutProps {
  id: string;
}

interface AuthContextData {
  user: User;
  signIn(credencials: SignInCredencials): Promise<void>;
  signOut(): void;
  updateUser(user: User): void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

//@ts-ignore
export const AuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const userStorage = localStorage.getItem("@qthadmin:user");
    const tokenStorage = localStorage.getItem("@qthadmin:token");

    if (userStorage && tokenStorage) {
      const userLogged = JSON.parse(userStorage) as User;
      //@ts-ignore
      api.defaults.headers.authorization = `Bearer ${tokenStorage}`;
      return { token: tokenStorage, user: userLogged };
    } 
    return {} as AuthState
  });

  useEffect(() => {
    function loadUserStorageData() {
      const tokenStorage = localStorage.getItem("@qthadmin:token");
      if (tokenStorage) {
        //@ts-ignore
        api.defaults.headers.authorization = `Bearer ${tokenStorage}`;
      } 
    }

    loadUserStorageData();
  }, []);

  //@ts-ignore
  const signIn = useCallback(async ({ email, password }): Promise<void> => {
    const response = await api.post("/628ba42a90cd30cdcdbbfe8a/login", {
      email,
      password,
      isAdmin: true,
    });

    console.log(response.data);

    const { token, user } = response.data;

    localStorage.setItem("@qthadmin:token", token);
    localStorage.setItem("@qthadmin:user", JSON.stringify(user));

    //@ts-ignore
    api.defaults.headers.authorization = `Bearer ${token}`;
    /* api.defaults.baseURL = `${url}/${company}`; */

    setData({ token, user });
  }, []);

  const updateUser = useCallback(
    (user: User) => {
      localStorage.setItem("@qthadmin:user", JSON.stringify(user));

      setData({
        token: data.token,
        user,
      });
    },
    [data.token]
  );

  const signOut = useCallback(() => {
    localStorage.removeItem("@qthadmin:token");
    localStorage.removeItem("@qthadmin:user");

    /* api.defaults.baseURL = url; */

    setData({} as AuthState);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user: data.user,
        signIn,
        signOut,
        updateUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within a AuthProvider");
  }

  return context;
}
